<div class="dalel-chrome" dir="rtl">
  <div class="top-strip">
    <div class="shell">
      <span>منصة واحدة لكل مناسباتك وخدماتك اليومية</span>
      <a class="top-link" routerLink="/nearest">اكتشف مقدمي الخدمة ←</a>
    </div>
  </div>

  <header class="site-header">
    <div class="shell nav">
      <a class="brand" (click)="goToHome()">
        <img src="assets/images/home/logo.png" alt="دليل بلس" />
        <span class="brand-copy">منصة<br /><b>دليل بلس</b></span>
      </a>

      <nav class="nav-links hide-mobile">
        <a routerLink="/home" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
          الرئيسية
        </a>
        <a routerLink="/nearest" routerLinkActive="active">مقدمو الخدمات</a>
        <a
          class="nav-sp"
          routerLink="/auth/sp-signup"
          *ngIf="!user || user?.user_type == 'user'"
        >
          كن مقدم خدمة
        </a>
      </nav>

      <div class="nav-actions hide-mobile">
        <ng-container *ngIf="!user">
          <a routerLink="/auth/signin" class="btn btn-outline">تسجيل الدخول</a>
          <a routerLink="/auth/register" class="btn btn-primary">إنشاء حساب</a>
        </ng-container>

        <ng-container *ngIf="user">
          <a
            *ngIf="user?.user_type == 'user'"
            class="btn btn-fav"
            routerLink="/account/favorites"
            aria-label="المفضلة"
          >
            <i class="fa-solid fa-heart"></i>
            <span class="btn-fav__badge" *ngIf="wishListCount > 0">{{ wishListCount }}</span>
          </a>
          <a routerLink="/account" class="user-chip" [attr.title]="userName">
            <img [src]="userImage" alt="" class="user-chip__avatar" />
            <span class="user-chip__text">
              <span class="user-chip__hello">أهلاً،</span>
              <span class="user-chip__name">{{ userName }}</span>
            </span>
          </a>
          <button type="button" class="btn btn-outline" (click)="logout()">خروج</button>
        </ng-container>
      </div>

      <div class="mobile-tools">
        <a
          class="btn btn-outline btn-sm"
          routerLink="/auth/sp-signup"
          *ngIf="!user || user?.user_type == 'user'"
        >
          كن مقدم خدمة
        </a>
        <button
          type="button"
          class="menu-btn"
          [class.is-open]="isNavMenuOpen"
          (click)="toggleNavMenu()"
          aria-label="القائمة"
        >
          ☰
        </button>
      </div>
    </div>
  </header>

  <div class="mobile-panel" [class.open]="isNavMenuOpen">
    <a routerLink="/home" (click)="closeMobileMenu()">الرئيسية</a>
    <a routerLink="/nearest" (click)="closeMobileMenu()">مقدمو الخدمات</a>
    <a
      routerLink="/auth/sp-signup"
      *ngIf="!user || user?.user_type == 'user'"
      (click)="closeMobileMenu()"
    >
      كن مقدم خدمة
    </a>
    <ng-container *ngIf="user">
      <a routerLink="/account" (click)="closeMobileMenu()">الحساب الشخصي</a>
      <a
        *ngIf="user?.user_type == 'user'"
        routerLink="/account/favorites"
        (click)="closeMobileMenu()"
      >
        المفضلة
      </a>
      <button type="button" (click)="logout(); closeMobileMenu()">تسجيل خروج</button>
    </ng-container>
    <ng-container *ngIf="!user">
      <a routerLink="/auth/signin" class="btn btn-outline" (click)="closeMobileMenu()">
        تسجيل الدخول
      </a>
      <a routerLink="/auth/register" class="btn btn-primary" (click)="closeMobileMenu()">
        إنشاء حساب
      </a>
    </ng-container>
  </div>

  <div class="overlay" [class.visible]="isNavMenuOpen" (click)="toggleNavMenu()"></div>
</div>
